import { convertFieldValueAvroToJson } from 'rpc-client-utils';
export function toSearchTicket(ticket) {
  if (typeof ticket.hs_ticket_id !== 'number') {
    throw new TypeError('Search result is missing a numeric hs_ticket_id');
  }
  if (ticket.status !== 'OPEN' && ticket.status !== 'CLOSED') {
    console.error('Search result has no valid OPEN or CLOSED status', {
      ticketId: ticket.hs_ticket_id,
      status: ticket.status
    });
    return Object.assign({}, ticket, {
      status: undefined
    });
  }
  return ticket;
}
export function decodeSearchTicket(ticket) {
  const decodedTicket = {};
  for (const [key, value] of Object.entries(ticket)) {
    decodedTicket[key] = convertFieldValueAvroToJson(value);
  }
  return toSearchTicket(decodedTicket);
}